import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'statut'
})
export class StatutPipe implements PipeTransform {

  transform(value: string): string {
    return value.toLowerCase().replace(" ", "")
  }

}
